import React from 'react';

import {
	formatBytes,
} from 'Crow/Form/Field/Custom/Vulture/Chonky/lib';

import style from './BackgroundDownloads.module.css';

// Non-blocking progress card for library downloads (DEV-11930).
//
// Deliberately NOT the LoadingView overlay: a download can run for minutes and the
// user must be able to keep working in the portal while it does. Rendered at the
// app level so it stays put when the user navigates away from the Library.
const BackgroundDownloadsView = function (props) {
	const {
		downloads,
	} = props;

	const entries = Object.values(downloads || {});

	if (entries.length === 0) {
		return null;
	}

	return (
		<div className={style.container} data-test-id="backgroundDownloads">
			{entries.map((download) => {
				const {
					id,
					label,
					percent,
					receivedBytes,
					totalBytes,
				} = download;

				let detail = '';
				if (receivedBytes > 0 && totalBytes > 0) {
					detail = `${formatBytes(receivedBytes)} of ${formatBytes(totalBytes)}`;
				} else if (receivedBytes > 0) {
					detail = formatBytes(receivedBytes);
				}

				return (
					<div key={id} className={style.card}>
						<div className={style.label}>{label}</div>
						<div className={style.bar}>
							<div
								className={percent === null ? style.fillIndeterminate : style.fill}
								style={percent === null ? undefined : {
									width: `${percent}%`,
								}}
							/>
						</div>
						{detail &&
							<div className={style.detail}>{detail}</div>
						}
					</div>
				);
			})}
		</div>
	);
};

export default BackgroundDownloadsView;
